import React, { Component } from "react";
import {
  ScrollView,
  View,
  StyleSheet,
  TouchableHighlight,
  // Dimensions,
  Platform,
} from "react-native";
import Switch from "../components/ToggleSwitch";
import Text from "../components_v2/TextFont";
import { connect } from "react-redux";
import DateRangePicker from "../components/DateRangePicker";
import Timeline from "react-native-timeline-flatlist";

import { translate, CurrentLocale } from "../locales/translate";
import Loading from "../components/Loading";
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import {
  faDoorClosed,
  faDoorOpen,
  faFile,
  faHome,
  faRunning,
  faShieldCross,
  faSyncAlt,
  faUser,
  faWand,
} from "../../assets/consts/faCharCodes";

import BarChart from "../components_v2/BarChart";
import { ArButton } from "../argon-ui";

import Theme from "../argon-ui/Theme";
import * as DeviceTypes from "../components/devices/_deviceTypes";
import { SimpleIcon } from "../components_v2/Buttons";
import { getIconByDeviceType } from "../actions/DeviceHelper";
let moment = require("moment-jalaali");

// const SCREEN_HEIGHT = Dimensions.get("screen").height;
// const SCREEN_WIDTH = Dimensions.get("screen").width;
const IS_MOBILE = Platform.OS === "android" || Platform.OS == "ios";
class DeviceLogScreen extends Component {
  constructor(props) {
    super(props);

    let _deviceId = 0;
    let _deviceUId = "";
    let deviceType = this.props.navigation.state.params.deviceType || "";
    let phaseNumber = this.props.navigation.state.params.phaseNumber || 0;
    if (
      this.props.navigation.state.params &&
      this.props.navigation.state.params.deviceId &&
      this.props.navigation.state.params.deviceUId
    ) {
      _deviceId = this.props.navigation.state.params.deviceId;
      _deviceUId = this.props.navigation.state.params.deviceUId;
    }

    this.state = {
      isConsumptionLoading: true,
      isTimelineLoading: true,
      isUsagePowerLoading: true,
      serverUrl: undefined,
      accessToken: undefined,
      buildingId: "",
      deviceId: _deviceId,
      deviceUId: _deviceUId,
      deviceName: "",
      deviceType,
      phaseNumber,
      lastUsagePowerValue: undefined,
      lastUsagePowerDate: undefined,
      lastUsagePowerUnit: "W",
      consumptionData: [],
      consumptionTotalUsage: "",
      totalUsageText: translate("deviceLog.totalUsage"),
      timeLine: [],
      timelineFilters: {
        isLoadingMore: false,
        page: 1,
        withDevice: true,
        withUser: true,
        withScenario: true,
        withArm: true,
        withState: true,
        withDoor: true,
        withUserIdentify: true,
      },
      showDatePicker: false,
      dateFrom: null,
      dateTo: null,
      monthlyStartYear: undefined,
      monthlyStartMonth: 1,
      monthlyEndYear: undefined,
      monthlyEndMonth: 1,
      duration: "today",
      customDuration: "daily",
      locale: CurrentLocale,
    };
  }
  static navigationOptions = ({ screenProps: { translate } }) => ({
    headerTitle: translate("navigation.DeviceLogs"),
  });
  componentDidMount() {
    let { currentServer, currentBuilding, serverUrl } = this.props.appReducer;
    if (!serverUrl.endsWith("/")) serverUrl += "/";
    this.setState({
      serverUrl,
      accessToken: currentServer.accessToken,
      buildingId: currentBuilding?.buildingId || "",
    });

    if (this.state.deviceId) {
      let { list } = this.props.reducer;
      for (var i in list) {
        let dvc = list[i];
        if (
          (dvc.deviceId == this.state.deviceId ||
            dvc.deviceUId == this.state.deviceId) &&
          (!this.state.deviceType || this.state.deviceType == dvc.deviceType) &&
          (dvc.deviceType != DeviceTypes.VOLTAGE_SENSOR ||
            dvc.phaseNumber == this.state.phaseNumber)
        ) {
          var _deviceType = this.state.deviceType || dvc.deviceType;
          this.setState(
            {
              deviceName: dvc.deviceName,
              deviceType: _deviceType,
            },
            () => {
              this.getAllReports();
            }
          );
          break;
        }
      }
    }
  }

  getAllReports = () => {
    this.getConsumptionReport();
    this.getTimelineLog();
    this.getLastUsagePower();
  };

  getConsumptionReport = () => {
    let {
      serverUrl,
      accessToken,
      deviceType,
      buildingId,
      deviceId,
      deviceUId,
      duration,
      dateFrom,
      dateTo,
      customDuration,
      locale,
    } = this.state;
    if (this._canGetConsumptionData()) {
      this.setState({ isConsumptionLoading: true, showDatePicker: false });
      if (serverUrl) {
        if (!serverUrl.endsWith("/")) serverUrl += "/";
        // filters
        var filters = [];

        filters.push(`buildingId=${buildingId}`);

        if (duration) filters.push(`duration=${duration}`);

        if (dateFrom) filters.push(`from=${new Date(dateFrom).toDateString()}`);

        if (dateTo) filters.push(`to=${new Date(dateTo).toDateString()}`);

        if (customDuration) filters.push(`customDuration=${customDuration}`);
        if (deviceId) {
          filters.push(`id=${deviceId}`);
        }
        if (deviceUId) {
          filters.push(`uId=${deviceUId}`);
        }
        filters.push(`locale=${locale || ""}`);
        // end filters

        var url = `${serverUrl}PowerConsumption/Device?${filters.join("&")}`;
        fetch(url, {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          // body: JSON.stringify({
          // }),
        })
          .then((res) => {
            this.setState({
              isConsumptionLoading: false,
            });
            return res.json();
          })
          .then((resj) => {
            if ((resj?.deviceId || resj.deviceUId) && resj.logs != null) {
              this.setState({
                consumptionData: resj.logs,
                consumptionTotalUsage: `${resj.totalUsage} ${resj.unit}`,
                isConsumptionLoading: false,
                totalUsageText: resj.isBatteryPowered
                  ? translate("deviceLog.batteryLevel")
                  : translate("deviceLog.totalUsage"),
              });
            } else {
              this.setState({
                serverAuthErrors: resj.errors,
                isConsumptionLoading: false,
              });
            }
          })
          .catch((err) => {
            {
              console.log(err);
              this.setState({ isConsumptionLoading: false });
            }
          });
      }
    }
  };

  // watt
  getLastUsagePower = () => {
    if (this._canGetConsumptionData()) {
      this.setState({ isUsagePowerLoading: true }, () => {
        let { serverUrl, accessToken, deviceId, deviceUId, buildingId } =
          this.state;
        if (serverUrl) {
          if (!serverUrl.endsWith("/")) serverUrl += "/";
          var filters = [];
          filters.push(`buildingId=${buildingId}`);
          if (deviceId) {
            filters.push(`id=${deviceId}`);
          }
          if (deviceUId) {
            filters.push(`uId=${deviceUId}`);
          }
          var url = `${serverUrl}PowerConsumption/UsagePower?${filters.join(
            "&"
          )}`;
          fetch(url, {
            method: "get",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
            // body: JSON.stringify({
            // }),
          })
            .then((res) => {
              this.setState({
                isUsagePowerLoading: false,
              });
              return res.json();
            })
            .then((resj) => {
              if (resj.power != null) {
                this.setState({
                  lastUsagePowerDate: resj.logDate,
                  lastUsagePowerValue: resj.power,
                  lastUsagePowerUnit: resj.unit || "W",
                  isUsagePowerLoading: false,
                });
              } else {
                this.setState({
                  serverAuthErrors: resj.errors,
                  isUsagePowerLoading: false,
                });
              }
            })
            .catch((err) => {
              {
                console.log(err);
                this.setState({ isUsagePowerLoading: false });
              }
            });
        }
      });
    }
  };

  _canGetConsumptionData = () => {
    // exclude by deviceTypes:
    return (
      this.state.deviceType != DeviceTypes.DOORBELL &&
      this.state.deviceType != DeviceTypes.DOORLOCK &&
      this.state.deviceType != DeviceTypes.CAMERA &&
      this.state.deviceType != DeviceTypes.SENSOR &&
      this.state.deviceType != DeviceTypes.MOTION_SENSOR &&
      this.state.deviceType != DeviceTypes.LIGHT_METER &&
      this.state.deviceType != DeviceTypes.THERMO_METER &&
      this.state.deviceType != DeviceTypes.HUMIDITY_SENSOR &&
      this.state.deviceType != DeviceTypes.DOOR_SENSOR &&
      this.state.deviceType != DeviceTypes.LEAK_DETECTOR &&
      this.state.deviceType != DeviceTypes.SMOKE_DETECTOR &&
      this.state.deviceType != DeviceTypes.SENSOR_BINARY &&
      this.state.deviceType != DeviceTypes.VOLTAGE_SENSOR
    );
  };

  getTimelineLog = (keepLogs = false) => {
    let {
      serverUrl,
      accessToken,
      timelineFilters,
      buildingId,
      deviceId,
      deviceUId,
      deviceType,
    } = this.state;
    timelineFilters.isLoadingMore = true;
    this.setState({
      isTimelineLoading: !keepLogs && true,
      timelineFilters,
      showDatePicker: false,
    });
    if (serverUrl) {
      if (!serverUrl.endsWith("/")) serverUrl += "/";
      // filters
      var filters = [];

      let { page, withDevice, withScenario, withUser, withState, withDoor, withUserIdentify } =
        this.state.timelineFilters;
      filters.push(`buildingId=${buildingId}`);
      filters.push(`d=${withDevice}`);
      filters.push(`s=${withScenario}`);
      filters.push(`u=${withUser}`);
      filters.push(`a=False`); // keep filter for backward compatibility but hard coded to false.(area arm filter merged to area states in backend.)
      filters.push(`st=${withState}`);
      filters.push(`door=${withDoor}`);
      filters.push(`ident=${withUserIdentify}`);
      if (deviceId) {
        filters.push(`id=${deviceId}`);
      }
      if (deviceUId) {
        filters.push(`uId=${deviceUId}`);
      }
      // === deviceType ===
      if (deviceType) {
        filters.push(`deviceType=${deviceType || ""}`);
      }
      if (page > 1) filters.push(`p=${page}`);

      // end filters

      var url = `${serverUrl}Log/DeviceTimeLine?${filters.join("&")}`;
      fetch(url, {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        // body: JSON.stringify({
        // }),
      })
        .then((res) => {
          timelineFilters.isLoadingMore = false;

          this.setState({
            isTimelineLoading: false,
            timelineFilters,
          });
          return res.json();
        })
        .then((resj) => {
          if ((resj?.deviceId || resj.deviceUId) && resj.logs != null) {
            if (resj.p && resj.p > 1) {
              // for pages above 1, push new logs to old ones.
              timelineFilters.isLoadingMore = false;
              this.setState({
                timeLine: [...this.state.timeLine, ...resj.logs],
                isTimelineLoading: false,
                timelineFilters,
              });
            } else {
              // but if page is not specified or page == 1, override timeline with new logs.
              timelineFilters.isLoadingMore = false;

              this.setState({
                timeLine: resj.logs,
                isTimelineLoading: false,
                timelineFilters,
              });
            }
          } else {
            timelineFilters.isLoadingMore = false;

            this.setState({
              serverAuthErrors: resj.errors,
              isTimelineLoading: false,
              timelineFilters,
            });
          }
        })
        .catch((err) => {
          {
            console.log(err);
            timelineFilters.isLoadingMore = false;

            this.setState({ isTimelineLoading: false, timelineFilters });
          }
        });
    }
  };

  toggleDatePicker = () => {
    this.setState({ showDatePicker: !this.state.showDatePicker });
  };

  handleOnDatePick = (tick, p) => {
    let f = this.state.dateFrom != null;
    let t = this.state.dateTo != null;
    if (p == "START_DATE") {
      //(f && t) || (!f && !t) both are selected or both are empty
      // set from date and clear toDate
      this.setState({ dateFrom: tick, dateTo: null });
    } else {
      this.setState({ dateTo: tick });
    }
  };

  renderConsumptionChart = () => {
    if (!this._canGetConsumptionData()) {
      return null;
    }
    if (this.state.isConsumptionLoading) {
      return <Loading message={translate("app.pleaseWaite")} />;
    }
    return (
      <View style={styles.section}>
        <Text style={styles.chartTitle}>
          {translate("deviceLog.powerConsumption")}
        </Text>
        <DateRangePicker
          duration={this.state.duration}
          customDurationType={this.state.customDuration}
          from={this.state.dateFrom}
          to={this.state.dateTo}
          monthlyStartYear={this.state.monthlyStartYear}
          monthlyStartMonth={this.state.monthlyStartMonth}
          monthlyEndYear={this.state.monthlyEndYear}
          monthlyEndMonth={this.state.monthlyEndMonth}
          onDurationChange={(duration) =>
            this.setState({ duration }, () => {
              this.getConsumptionReport();
            })
          }
          onRefresh={this.getConsumptionReport}
          onDateChange={this.handleOnDatePick}
          onCustomDurationTypeChange={(type) =>
            this.setState({ customDuration: type }, () => {
              if (type == "monthly") {
                var jY = Number(moment(new Date().toString()).format("jYYYY"));
                var jM = Number(moment(new Date().toString()).format("jM")) - 1;

                var dateFrom = moment
                  .utc()
                  .jYear(jY)
                  .jMonth(0)
                  .jDate(1)
                  .toDate();
                var dateTo = moment
                  .utc()
                  .jYear(jY)
                  .jMonth(jM)
                  .jDate(1)
                  .toDate();

                this.setState({ dateFrom, dateTo }, () => {
                  this.getConsumptionReport();
                });
              } else {
                this.getConsumptionReport();
              }
            })
          }
          onMonthlyDurationChange={(data) => {
            let { endMonth, endYear, startMonth, startYear } = data;
            this.setState(
              {
                monthlyStartYear: startYear,
                monthlyStartMonth: startMonth,
                monthlyEndYear: endYear,
                monthlyEndMonth: endMonth,
                dateFrom: moment
                  .utc()
                  .jYear(startYear)
                  .jMonth(startMonth - 1)
                  .jDate(1)
                  .toDate(),
                dateTo: moment
                  .utc()
                  .jYear(endYear)
                  .jMonth(endMonth - 1)
                  .jDate(1)
                  .toDate(),
              },
              () => {
                this.getConsumptionReport();
              }
            );
          }}
        />
        {this.state.consumptionData &&
          this.state.consumptionData.length > 0 && (
            <View style={styles.chartWrapper}>
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Text
                  style={{
                    paddingHorizontal: 10,
                    // borderWidth: 1,
                    // borderColor: "red",
                    //flex: 1,
                  }}
                >
                  {this.state.totalUsageText}:
                </Text>
                <Text style={styles.totalUsage}>
                  {this.state.consumptionTotalUsage}
                </Text>
              </View>
              <BarChart data={this.state.consumptionData} />
            </View>
          )}
      </View>
    );
  };

  renderLastUsagePower = () => {
    if (!this._canGetConsumptionData()) {
      return null;
    }

    if (this.state.isUsagePowerLoading) {
      return <Loading message={translate("app.pleaseWaite")} />;
    }

    if (!this.state.lastUsagePowerValue) return null;

    return (
      <View style={styles.section}>
        <View style={styles.rowCenter}>
          <Text style={styles.chartTitle}>
            {translate("deviceLog.lastUsagePower")}
          </Text>
          <TouchableHighlight
            style={styles.refreshButton}
            onPress={this.getLastUsagePower}
          >
            <FontAwesomeIcon icon={faSyncAlt} color="#FFF" />
          </TouchableHighlight>
        </View>

        <View style={styles.rowCenter}>
          <Text style={{ paddingHorizontal: 10 }}>
            {this.state.lastUsagePowerDate}
          </Text>
          <Text style={[{ paddingHorizontal: 10 }, styles.totalUsage]}>
            {this.state.lastUsagePowerValue} {this.state.lastUsagePowerUnit}
          </Text>
        </View>
      </View>
    );
  };

  renderTimeline = () => {
    if (this.state.isTimelineLoading) {
      return <Loading message={translate("app.pleaseWaite")} />;
    }
    return (
      <View style={{ paddingTop: 15, width: "100%" }}>
        <View style={styles.timeLineWrapper}>
          <Text style={styles.chartTitle}>
            {translate("deviceLog.activities")}
          </Text>
          <View
            style={{
              flexDirection: "column",
              marginBottom: 15,
              marginHorizontal: 10,
              alignItems: "center",
              justifyContent: "center",
              alignContent: "center",
            }}
          >
            <View
              style={{
                flexDirection: "row",
                flexWrap: "wrap",
                alignItems: "stretch",
                justifyContent: "center",
                alignContent: "center",
                width: "100%",
                marginBottom: 12,
              }}
            >
              {/* with device */}
              <View
                style={[
                  {
                    flex: 1,
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginBottom: 5,
                    borderWidth: 1,
                    borderColor: Theme.COLORS.BORDER,
                    borderRadius: 15,
                    padding: 5,
                    minWidth: "auto",
                    marginLeft: 40,
                  },
                  // IS_MOBILE ? { marginRight: 40 } : { marginLeft: 40 },
                ]}
              >
                <Text style={{ flex: 1 }}>{translate("deviceLog.device")}</Text>
                <Switch
                  isOn={this.state.timelineFilters.withDevice}
                  onColor={Theme.COLORS.ACTIVE}
                  offColor={Theme.COLORS.MUTED}
                  size="small"
                  // onToggle={(v) => {
                  //   // let { timelineFilters } = this.state;
                  //   // timelineFilters.withState = v;
                  //   // timelineFilters.page = 1;
                  //   // this.setState({ timelineFilters });
                  //   // this.getTimelineLog();
                  // }}
                  onToggle={(v) => {
                    let { timelineFilters } = this.state;
                    timelineFilters.withDevice = v;
                    timelineFilters.page = 1;
                    this.setState({ timelineFilters });
                    this.getTimelineLog();
                  }}
                  animationSpeed={0}
                />
              </View>
              {/* end with device */}

              {/* with user */}
              <View
                style={{
                  flex: 1,
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginBottom: 5,
                  borderWidth: 1,
                  borderColor: Theme.COLORS.BORDER,
                  borderRadius: 15,
                  padding: 5,
                  minWidth: "auto",
                  marginLeft: 40,
                }}
              >
                <Text style={{ flex: 1 }}>{translate("deviceLog.user")}</Text>
                <Switch
                  isOn={this.state.timelineFilters.withUser}
                  onColor={Theme.COLORS.ACTIVE}
                  offColor={Theme.COLORS.MUTED}
                  size="small"
                  onToggle={(v) => {
                    let { timelineFilters } = this.state;
                    timelineFilters.withUser = v;
                    timelineFilters.page = 1;
                    this.setState({ timelineFilters });
                    this.getTimelineLog();
                  }}
                  animationSpeed={0}
                />
              </View>
              {/* end with user */}

              {/* with scenario */}
              {this.state.deviceType == DeviceTypes.ACCESS_CONTROL ? (
                ""
              ) : (
                <View
                  style={[
                    {
                      flex: 1,
                      flexDirection: "row",
                      justifyContent: "space-between",
                      marginBottom: 5,
                      borderWidth: 1,
                      borderColor: Theme.COLORS.BORDER,
                      borderRadius: 15,
                      padding: 5,
                      minWidth: "auto",
                      marginLeft: 40,
                    },
                    // IS_MOBILE ? { marginRight: 40 } : { marginLeft: 40 },
                  ]}
                >
                  <Text style={{ flex: 1 }}>
                    {translate("deviceLog.scenario")}
                  </Text>

                  <Switch
                    isOn={this.state.timelineFilters.withScenario}
                    onColor={Theme.COLORS.ACTIVE}
                    offColor={Theme.COLORS.MUTED}
                    size="small"
                    onToggle={(v) => {
                      let { timelineFilters } = this.state;
                      timelineFilters.withScenario = v;
                      timelineFilters.page = 1;
                      this.setState({ timelineFilters });
                      this.getTimelineLog();
                    }}
                    animationSpeed={0}
                  />
                </View>
              )}
              {/* end with scenario */}

              {/* start with arm */}
              {this.state.deviceType == DeviceTypes.ACCESS_CONTROL ? (
                ""
              ) : (
                <View
                  style={{
                    flex: 1,
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginBottom: 5,
                    borderWidth: 1,
                    borderColor: Theme.COLORS.BORDER,
                    borderRadius: 15,
                    padding: 5,
                    minWidth: "auto",
                    marginLeft: 40,
                  }}
                >
                  <Text style={{ flex: 1 }}>
                    {translate("deviceLog.areastate")}
                  </Text>
                  <Switch
                    isOn={this.state.timelineFilters.withState}
                    onColor={Theme.COLORS.ACTIVE}
                    offColor={Theme.COLORS.MUTED}
                    size="small"
                    onToggle={(v) => {
                      let { timelineFilters } = this.state;
                      timelineFilters.withState = v;
                      timelineFilters.page = 1;
                      this.setState({ timelineFilters });
                      this.getTimelineLog();
                    }}
                    animationSpeed={0}
                  />
                </View>
              )}
              {/* end with arm */}

              {/* start with door */}
              {this.state.deviceType != DeviceTypes.ACCESS_CONTROL ? (
                ""
              ) : (
                <View
                  style={{
                    flex: 1,
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginBottom: 5,
                    borderWidth: 1,
                    borderColor: Theme.COLORS.BORDER,
                    borderRadius: 15,
                    padding: 5,
                    minWidth: "auto",
                    marginLeft: 40,
                  }}
                >
                  <Text style={{ flex: 1 }}>
                    {translate("deviceLog.FILTER_DOOR")}
                  </Text>
                  <Switch
                    isOn={this.state.timelineFilters.withDoor}
                    onColor={Theme.COLORS.ACTIVE}
                    offColor={Theme.COLORS.MUTED}
                    size="small"
                    onToggle={(v) => {
                      let { timelineFilters } = this.state;
                      timelineFilters.withDoor = v;
                      timelineFilters.page = 1;
                      this.setState({ timelineFilters });
                      this.getTimelineLog();
                    }}
                    animationSpeed={0}
                  />
                </View>
              )}
              {/* end with door */}

              {/* start with user identify */}
              {this.state.deviceType != DeviceTypes.ACCESS_CONTROL ? (
                ""
              ) : (
                <View
                  style={{
                    flex: 1,
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginBottom: 5,
                    borderWidth: 1,
                    borderColor: Theme.COLORS.BORDER,
                    borderRadius: 15,
                    padding: 5,
                    minWidth: "auto",
                    marginLeft: 40,
                  }}
                >
                  <Text style={{ flex: 1 }}>
                    {translate("deviceLog.FILTER_IDENTIFY")}
                  </Text>
                  <Switch
                    isOn={this.state.timelineFilters.withUserIdentify}
                    onColor={Theme.COLORS.ACTIVE}
                    offColor={Theme.COLORS.MUTED}
                    size="small"
                    onToggle={(v) => {
                      let { timelineFilters } = this.state;
                      timelineFilters.withUserIdentify = v;
                      timelineFilters.page = 1;
                      this.setState({ timelineFilters });
                      this.getTimelineLog();
                    }}
                    animationSpeed={0}
                  />
                </View>
              )}
              {/* end with door */}

            </View>
          </View>
          {this.state.timeLine && this.state.timeLine.length > 0 && (
            <View style={{ direction: "ltr" }}>
              <Timeline
                data={this.state.timeLine}
                eventContainerStyle={{}}
                timeStyle={{
                  minWidth: 120,
                }}
                columnFormat={
                  IS_MOBILE ? "single-column-left" : "single-column-right"
                }
                renderDetail={(rowData) => {
                  var _isState =
                    rowData.cause == "scenario" ||
                    rowData.cause == "areaarm" ||
                    rowData.cause == "areastate" ||
                    rowData.cause == "areabreach";

                  var icon = undefined;
                  switch (rowData.cause) {
                    case "device":
                      if (rowData.deviceType == DeviceTypes.DOOR_SENSOR)
                        icon = rowData.status == 0 ? faDoorClosed : faDoorOpen;
                      else icon = getIconByDeviceType(rowData.deviceType);
                      break;
                    case "user":
                      icon = faUser;
                      break;
                    case "scenario":
                      icon = faWand;
                      break;
                    case "areaarm":
                      icon = faShieldCross;
                      break;
                    case "areastate":
                      icon = faHome;
                      break;
                    case "areabreach":
                      icon = faRunning;
                      break;
                    default:
                      icon = faFile;
                      break;
                  }

                  var rowTitle = null;
                  // console.log(rowData)
                  if (rowData.cause == "device") {
                    rowTitle = (
                      <Text style={{ fontWeight: "bold" }}>
                        {!rowData.deviceType && (
                          <Text>{translate(`deviceLog.device`)}: </Text>
                        )}
                        {translate(`deviceLog.${rowData.title}`)}
                      </Text>
                    );
                  } else {
                    rowTitle = (
                      <Text style={{ fontWeight: "bold" }}>
                        {translate(`deviceLog.${rowData.cause}`)}:{" "}
                        {rowData.title}
                      </Text>
                    );
                  }

                  var wrapperStyle = [styles.timeLineItem];
                  if (_isState) wrapperStyle.push(styles.timeLineItemState);
                  if (rowData.status == 255)
                    wrapperStyle.push(styles.timeLineItemActive);
                  else if (rowData.status == 0)
                    wrapperStyle.push(styles.timeLineItemDeActive);
                  else wrapperStyle.push(styles.timeLineItemNeutral);

                  return (
                    <View style={wrapperStyle}>
                      <View style={{ flex: 1, marginEnd: 10 }}>
                        {rowTitle}
                        <Text style={{}}>
                          {rowData.description == "ChangeCommandSent"
                            ? rowData.status == undefined || rowData.status < 0
                              ? translate(`deviceLog.ChangeCommandSentNoStatus`)
                              : translate(`deviceLog.${rowData.description}`, {
                                  status: rowData.status,
                                })
                            : rowData.status > 0 &&
                              rowData.description.startsWith(rowData.status)
                            ? rowData.description
                            : translate(`deviceLog.${rowData.description}`)}
                        </Text>
                        {rowData.description2 && (
                          <Text>{rowData.description2}</Text>
                        )}
                      </View>
                      <SimpleIcon icon={icon} size={20} />
                    </View>
                  );
                }}
              />
            </View>
          )}
          {this.renderTimelineLoadMore()}
        </View>
      </View>
    );
  };

  renderTimelineLoadMore = () => {
    if (this.state.timelineFilters.isLoadingMore) {
      return <Loading message="" />;
    } else if (this.state.timeLine.length > 0) {
      return (
        <ArButton
          style={{ marginBottom: 20, alignSelf: "center" }}
          color="primary"
          onPress={() => {
            let { timelineFilters } = this.state;
            timelineFilters.page++;
            timelineFilters.isLoadingMore = true;
            this.setState({ timelineFilters }, () => {
              this.getTimelineLog(true);
            });
          }}
        >
          <Text style={{ color: "#FFF" }}>
            {translate("deviceLog.olderLogs")}
          </Text>
        </ArButton>
      );
    }
    return null;
  };

  render() {
    return (
      <ScrollView>
        <View style={{ alignItems: "center" }}>
          <Text
            style={{ fontSize: 18, fontWeight: "bold", paddingVertical: 10 }}
          >
            {this.state.deviceName}
          </Text>
          {this.state.deviceType == DeviceTypes.ACCESS_CONTROL
            ? ""
            : this.renderConsumptionChart()}
          {this.state.deviceType == DeviceTypes.ACCESS_CONTROL
            ? ""
            : this.renderLastUsagePower()}
          {this.renderTimeline()}
        </View>
      </ScrollView>
    );
  }
}

const styles = StyleSheet.create({
  section: {
    borderTopColor: Theme.COLORS.BORDER,
    borderTopWidth: 1,
    paddingTop: 15,
    width: "100%",
  },
  chartWrapper: {
    marginVertical: 15,
    padding: 10,
    borderRadius: 10,
    backgroundColor: Theme.COLORS.BLOCK,
  },
  chartTitle: {
    fontSize: 18,
    padding: 10,
  },
  totalUsageText: {
    fontWeight: "bold",
    fontSize: 36,
    textAlign: "left",
    writingDirection: "ltr",
    color: Theme.COLORS.MUTED,
    // borderWidth: 1,
    // borderColor: "green",
    //flex: 1,
  },
  timeLineWrapper: {
    marginTop: 15,
    width: "100%",
    paddingHorizontal: 10,
    borderTopColor: Theme.COLORS.BORDER,
    borderTopWidth: 1,
    paddingTop: 15,
  },
  timeLineEventContainer: {
    backgroundColor: "#fea320",
    borderRadius: 15,
    marginBottom: 15,
  },
  totalUsage: {
    fontWeight: "bold",
    fontSize: 36,
    textAlign: "left",
    writingDirection: "ltr",
    // borderWidth: 1,
    // borderColor: "green",
    //flex: 1,
    marginBottom: 10,
  },
  rowCenter: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  refreshButton: {
    marginHorizontal: 10,
    backgroundColor: Theme.COLORS.WARNING,
    borderRadius: 15,
    width: 30,
    height: 30,
    alignItems: "center",
    justifyContent: "center",
  },
  timeLineItem: {
    borderRadius: 15,
    borderWidth: 0,
    borderColor: "transparent",
    padding: 15,
    flex: 1,
    flexDirection: "row",
  },
  timeLineItemActive: { backgroundColor: "#ffa726" },
  timeLineItemDeActive: { backgroundColor: Theme.COLORS.MUTED },
  timeLineItemNeutral: { backgroundColor: "#d4e4ff" },
  timeLineItemState: {
    backgroundColor: "#66999910",
    borderColor: "#669999",
    borderWidth: 1,
  },
});

const mapStateToProps = (state) => {
  return {
    reducer: state.DeviceReducer,
    appReducer: state.AppReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(DeviceLogScreen);
